import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { dummyAction } from '../main/actions'

import MainMenu from './MainMenu';
import { pageLocations } from './pageInfo'

const mapStateToProps = (state, ownProps) => {
  return {
    active: ownProps.potato === state.potato
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onTap: () => {
      dispatch(dummyAction(ownProps.potato))
    },
    gotoSection: (name)=>{
      let newLocation = pageLocations[name];
      if(newLocation !== undefined){
        ownProps.history.push(newLocation);
      }
    }
  }
}

const MenuModule = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainMenu)

const MenuModuleWithRouter = withRouter(MenuModule);

export default MenuModuleWithRouter;



// WEBPACK FOOTER //
// ./src/modules/menu/container.js